<template>
    <div class="wish-wall">
        <!-- <div class="img-arr">
            <img :src="item?.userPortrait" :key="index" v-for="(item, index) in danmus" />
        </div> -->
        <div class="pc-wrap">
            <img
                src="https://m.elongstatic.com/year-wish/2025-title1.png"
                alt=""
                class="pc-title"
            />
            <audio
                v-if="audioUrl"
                :src="audioUrl"
                ref="player"
                preload="true"
                @ended="ended"
            ></audio>
            <img
                src="https://m.elongstatic.com/year-wish/tongcheng-logo.png"
                class="pc-logo"
                alt=""
            />
            <div class="wish-wrap">
                <vueDanmaku
                    ref="danmaku"
                    v-model="danmus"
                    use-slot
                    :loop="true"
                    :hidden="isHidden"
                    :speeds="dmSpeed"
                    :channels="0"
                    :randomChannel="false"
                    style="height: 100%; width: 100%"
                    :isSuspend="false"
                    :top="60"
                    :right="60"
                    :debounce="500"
                    @play-end="listEnd"
                    @list-end="listEnd"
                    controls
                >
                    <template slot="dm" slot-scope="{ index, danmu }">
                        <div class="noTorem-wish-box">
                            <!-- <div class="noTorem-user-portrait">
                                <van-image width="40px" height="40px" radius="4px"
                                    :src="danmu.userPortrait || 'http://m.elongstatic.com/year-wish/wish-default.png'"
                                    fit="cover" />
                            </div> -->
                            <div class="noTorem-wish-right">
                                <!-- <div class="noTorem-user-name">{{ danmu.userName }}</div> -->
                                <div class="noTorem-wish-bg" @click="openDetail(danmu)">
                                    <!-- <div class="noTorem-wish-bg-triangle"></div> -->
                                    <!-- <div class="noTorem-wish-voice" @click="playOrPause(danmu, index)"> -->
                                    <!-- <div class="noTorem-wish-voice" v-if="danmu.wishVoiceTempUrl">
                                        <audioPlay :isPlay="(isPlay && playIndex === index)"
                                            :second="danmu.wishVoiceLength"></audioPlay>
                                        <div class="noTorem-voice-click-text">听听心愿</div>
                                    </div> -->
                                    <div
                                        class="noTorem-like-box"
                                        @click.stop="handleLikeClick($event, danmu)"
                                    >
                                        <div class="noTorem-like-img">
                                            <img
                                                v-if="
                                                    danmu.myLikeState === 0 &&
                                                    showLikeGifId !== danmu.id
                                                "
                                                src="https://m.elongstatic.com/year-wish/2025-unlike.png"
                                                alt=""
                                                class="noTorem-unlike"
                                            />
                                            <img
                                                v-if="
                                                    danmu.myLikeState === 1 &&
                                                    showLikeGifId !== danmu.id
                                                "
                                                src="https://m.elongstatic.com/year-wish/2025-like.png"
                                                alt=""
                                                class="noTorem-like"
                                            />
                                        </div>
                                        <img
                                            v-if="showLikeGifId === danmu.id"
                                            src="https://m.elongstatic.com/year-wish/like.gif"
                                            alt=""
                                            class="noTorem-like-gif"
                                        />
                                        <div class="noTorem-likeNum">
                                            {{ danmu.likeNum }}
                                        </div>
                                    </div>
                                    <div
                                        :class="{
                                            'noTorem-wish-content': true,
                                            'noTorem-wish-content3': !danmu.wishVoiceTempUrl,
                                        }"
                                    >
                                        {{ danmu.wishText }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </vueDanmaku>
            </div>
            <!-- <div class="noTorem-show-btn" @click="openWishDrawDialog"></div>  -->
            <div @click="openCheckWish" class="show-btn"></div>
            <!-- 小程序码去填写 -->
            <van-overlay :show="showCodeDialog" z-index="999">
                <div class="codeWrapper" @click.stop>
                    <div class="dialog">
                        <img
                            class="dialog-close"
                            src="https://m.elongstatic.com/year-wish/wish-close-icon.png"
                            @click="closeQrDialog"
                        />
                        <img
                            class="qr-bg"
                            src="https://m.elongstatic.com/year-wish/code-icon.png"
                        />

                        <div class="qr-img">
                            <img v-if="!loading" class="qrImgUrl" :src="qrImgUrl" />
                            <van-loading v-if="loading" class="loading" />
                        </div>

                        <div class="qr-desc">
                            扫描上方二维码，快来参加年会祝福活动吧～
                        </div>
                    </div>
                </div>
            </van-overlay>
            <!-- 小程序码查看祝福 -->
            <van-overlay :show="showcheckWishDialog" z-index="999">
                <div class="codeWrapper" @click.stop>
                    <div class="dialog">
                        <img
                            class="dialog-close"
                            src="https://m.elongstatic.com/year-wish/wish-close-icon.png"
                            @click="showcheckWishDialog = false"
                        />
                        <img
                            class="qr-bg"
                            src="https://m.elongstatic.com/year-wish/code-icon.png"
                        />

                        <div class="qr-img">
                            <img v-if="!loading" class="qrImgUrl" :src="qrImgUrl" />
                            <van-loading v-if="loading" class="loading" />
                        </div>
                        <div class="qr-desc">扫描上方二维码，查看送出去的祝福</div>
                    </div>
                </div>
            </van-overlay>
            <!-- pc端查看单条祝福 -->
            <van-overlay :show="showDialog" z-index="999">
                <div class="checkWishWrapper" @click.stop>
                    <div class="dialog" v-if="showDialog">
                        <img
                            class="dialog-close"
                            src="https://m.elongstatic.com/year-wish/wish-close-icon.png"
                            @click="closePcDetail()"
                        />
                        <div class="dialog-head">
                            {{ isEnd ? "活动已截止" : "查看祝福" }}
                        </div>
                        <template v-if="isEnd && isShowMyself && !detail">
                            <div class="wish-box-end">
                                <img
                                    class="pc-end-icon"
                                    src="http://m.elongstatic.com/year-wish/end-icon.png"
                                />
                                <div class="pc-end-text">
                                    心愿提交已截止，您没有按时提交心愿
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="wish-content-box" v-if="detail">
                                <div class="wish-txt">
                                    {{ detail?.wishText }}
                                </div>
                            </div>
                            <div class="media" v-if="detail">
                                <div
                                    class="media-box"
                                    v-for="(item, index) in detail?.picList"
                                    :key="item"
                                >
                                    <div
                                        :class="{ 'media-item': true }"
                                        @click="showMedia(item)"
                                    >
                                        <video
                                            v-show="
                                                item.picType === 'video' && !isHideMedia
                                            "
                                            :src="item.picUrl"
                                            class="media-image"
                                            :class="{ 'hide-media': isHideMedia }"
                                            width="100px"
                                            height="100px"
                                        ></video>
                                        <img
                                            v-if="
                                                item.picType === 'video' && !item.isClick
                                            "
                                            src="https://m.elongstatic.com/year-wish/play-btn.png"
                                            class="videoPlayIcon"
                                            alt=""
                                        />
                                        <el-image
                                            v-if="item.picType === 'pic' || isHideMedia"
                                            class="media-image"
                                            :class="{ 'hide-media': isHideMedia }"
                                            :src="item.picUrl"
                                            :draggable="false"
                                            :lazy="true"
                                            fit="cover"
                                            :preview-src-list="
                                                isHideMedia ? [] : getPreviewList()
                                            "
                                        >
                                            <div slot="error" class="image-slot">
                                                <i class="el-icon-picture-outline"></i>
                                            </div>
                                        </el-image>
                                        <img
                                            v-if="item.isClick"
                                            src="https://m.elongstatic.com/year-wish/img-hidden-icon.png"
                                            class="unLookIcon"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </van-overlay>
            <!-- 首次点击引导动画 -->
            <van-overlay :show="showGuide" z-index="999" @click="closeGuide">
                <div class="click-tips-box">
                    <div class="tip-div">
                        <img
                            src="https://m.elongstatic.com/year-wish/click-tips.png"
                            alt=""
                        />
                    </div>
                    <div class="click-tip">试试看戳戳弹幕，会有惊喜哦 ～</div>
                </div>
            </van-overlay>
            <div class="dialog-box">
                <el-dialog
                    :fullscreen="true"
                    :center="true"
                    :visible.sync="dialogVisible"
                    width="50%"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    custom-class="video-dialog"
                    style="background: #000 !important"
                    @close="videoDialogClose"
                >
                    <div
                        class="video-container"
                        style="display: flex; flex-direction: column"
                    >
                        <video
                            v-if="dialogVisible"
                            :show-fullscreen-btn="false"
                            controls
                            class="video-player"
                            :height="windowHeight * 0.8"
                            ref="wishVideo"
                        >
                            <source
                                :src="
                                    getmedialist(detail).filter(
                                        (i) => determineFileType(i) === 'video'
                                    )[0]
                                "
                                type="video/mp4"
                            />
                        </video>
                    </div>
                </el-dialog>
            </div>
        </div>

        <div class="mobile-wrap">
            <!-- <img class="bg-title" src="https://m.elongstatic.com/year-wish/wishTitle2024.png" alt="" /> -->

            <div class="mobile-show-btn" @click="showDialog = true">查看我的心愿</div>

            <div class="wish-wrap2">
                <vueDanmaku
                    ref="danmaku"
                    v-model="danmus"
                    use-slot
                    :loop="true"
                    :speeds="60"
                    :channels="0"
                    :randomChannel="false"
                    style="height: 100%; width: 100%"
                    :isSuspend="true"
                    :top="30"
                    :right="17"
                    :debounce="500"
                    @play-end="listEnd"
                    @list-end="listEnd"
                >
                    <template slot="dm" slot-scope="{ index, danmu }">
                        <div class="noTorem-wish-box">
                            <!-- <div class="noTorem-user-portrait">
                                <van-image width="40px" height="40px" radius="4px"
                                    :src="danmu.userPortrait || 'http://m.elongstatic.com/year-wish/wish-default.png'"
                                    fit="cover" />
                            </div> -->
                            <div class="noTorem-wish-right">
                                <!-- <div class="noTorem-user-name">{{ danmu.userName }}</div> -->
                                <div class="noTorem-wish-bg" @click="openDetail(danmu)">
                                    <!-- <div class="noTorem-wish-bg-triangle"></div> -->
                                    <!-- <div class="noTorem-wish-voice" @click="playOrPause(danmu, index)"> -->
                                    <!-- <div class="noTorem-wish-voice" v-if="danmu.wishVoiceTempUrl">
                                        <audioPlay :isPlay="(isPlay && playIndex === index)"
                                            :second="danmu.wishVoiceLength"></audioPlay>
                                        <div class="noTorem-voice-click-text">听听心愿</div>
                                    </div> -->
                                    <div
                                        class="noTorem-like-box"
                                        @click.stop="handleLikeClick($event, danmu)"
                                    >
                                        <div class="noTorem-like-img">
                                            <img
                                                v-if="
                                                    danmu.myLikeState === 0 &&
                                                    showLikeGifId !== danmu.id
                                                "
                                                src="https://m.elongstatic.com/year-wish/2025-unlike.png"
                                                alt=""
                                                class="noTorem-unlike"
                                            />
                                            <img
                                                v-if="
                                                    danmu.myLikeState === 1 &&
                                                    showLikeGifId !== danmu.id
                                                "
                                                src="https://m.elongstatic.com/year-wish/2025-like.png"
                                                alt=""
                                                class="noTorem-like"
                                            />
                                        </div>
                                        <img
                                            v-if="showLikeGifId === danmu.id"
                                            src="https://m.elongstatic.com/year-wish/like.gif"
                                            alt=""
                                            class="noTorem-like-gif"
                                        />
                                        <div class="noTorem-likeNum">
                                            {{ danmu.likeNum }}
                                        </div>
                                    </div>
                                    <div
                                        :class="{
                                            'noTorem-wish-content': true,
                                            'noTorem-wish-content3': !danmu.wishVoiceTempUrl,
                                        }"
                                    >
                                        {{ danmu.wishText }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </vueDanmaku>
            </div>
            <!-- 移动端 -->
            <van-overlay :show="showDialog" z-index="999">
                <div class="wrapper">
                    <div class="detail-dialog">
                        <img
                            class="heart-img"
                            src="http://m.elongstatic.com/year-wish/img_heart@2x.png"
                        />
                        <div class="detail-text">查看心愿</div>
                        <div class="end-box" v-if="isEnd && isShowMyself && !detail">
                            <img
                                class="end-icon"
                                src="http://m.elongstatic.com/year-wish/end-icon.png"
                            />
                            <div class="end-text">心愿提交已截止，您没有按时提交心愿</div>
                        </div>
                        <template v-else>
                            <template v-if="detail">
                                <div class="detail-content">
                                    <div class="detail-content-text">
                                        {{ detail.wishText }}
                                    </div>
                                </div>
                                <div class="play-box">
                                    <div
                                        class="play-audio-box"
                                        @click="playOrPauseDetail(detail)"
                                    >
                                        <div class="audioPlay">
                                            <audioPlay
                                                type="wx"
                                                :isPlay="isPlayDetail"
                                                :second="detail.wishVoiceLength"
                                            ></audioPlay>
                                        </div>
                                    </div>
                                    <div class="play-desc">听听心愿</div>
                                </div>
                            </template>
                        </template>
                        <div class="ok-btn" @click="showDialog = false">好的</div>
                    </div>
                </div>
            </van-overlay>
        </div>

        <!-- 抽心愿 -->
        <van-overlay :show="showWishDialog" z-index="10000">
            <div class="lottery-wrap">
                <!-- <img class="huxideng" src="http://m.elongstatic.com/year-wish/bg_huxideng.png" /> -->
                <div class="lottery-box">
                    <img
                        class="lottery-title1"
                        src="http://m.elongstatic.com/year-wish/year-wish-lucky.png"
                    />
                    <div class="lottery-header">
                        <!-- <img src="http://m.elongstatic.com/year-wish/close2.png" @click="closeWishResult" /> -->
                    </div>
                    <div class="lottery-item-box">
                        <img
                            class="lottery-icon1"
                            src="http://m.elongstatic.com/year-wish/lottery-icon2.png"
                        />
                        <div class="lottery-arr">
                            <div
                                :class="`lottery-block-box `"
                                :key="index"
                                v-for="(item, index) in rollArr"
                            >
                                <div class="lottery-item">
                                    <div class="user-portrait">
                                        <!-- <img :src="item.userPortrait || 'http://m.elongstatic.com/year-wish/wish-default.png'" alt=""> -->
                                        <van-image
                                            v-if="isWishEnding"
                                            class="user-portrait-image"
                                            :src="
                                                item?.userPortrait ||
                                                'http://m.elongstatic.com/year-wish/wish-default.png'
                                            "
                                            fit="cover"
                                            radius="4px"
                                        />
                                    </div>

                                    <div class="lottery-item-right">
                                        <div class="user-name">{{ item.userName }}</div>
                                        <div :class="{ 'wish-bg1': true }">
                                            <!-- <div class="wish-bg-triangle1"></div> -->
                                            <div
                                                class="wish-voice1"
                                                @click="playOrPause(item, index)"
                                                v-if="item.wishVoiceTempUrl"
                                            >
                                                <audioPlay
                                                    :isPlay="
                                                        isPlay && playIndex === index
                                                    "
                                                    :second="item.wishVoiceLength"
                                                    type="yellow"
                                                >
                                                </audioPlay>
                                                <div class="voice-click-text">
                                                    听听心愿
                                                </div>
                                            </div>
                                            <div
                                                :class="{
                                                    'wish-content2': true,
                                                    'wish-content3': !item.wishVoiceTempUrl,
                                                }"
                                            >
                                                {{ item.wishText }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="lottery-footer" @click="pauseWishResult">停</div> -->
                    <div class="lottery-footer">
                        <!-- <div class="wish-draw-btn" @click="pauseWishResult">停</div> -->
                        <img
                            v-show="showWishBtn"
                            @click="pauseWishResult"
                            class="wish-draw-btn"
                            src="http://m.elongstatic.com/year-wish/year-wish-stop.png"
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
// import vueDanmaku from 'vue-danmaku'
import vueDanmaku from "../components/danmuku.vue";
import audioPlay from "../components/audioPlay.vue";
import {
    getWishList,
    wishDetail,
    qryWishTime,
    qryWishDraw,
    doWishDraw,
    applyfortoken,
    getQrImg,
    wishLike,
} from "../service/api";
import { Toast } from "vant";
import { Message } from "element-ui";
import { isTimeReached, debounce } from "../utils/utils";

import CryptoJS from "crypto-js";

export default {
    name: "wishWall",
    components: {
        vueDanmaku,
        audioPlay,
    },
    data() {
        return {
            // danmus:['111','222','343','wehf', 'sdfjsklf', 'sdfsdfsd','22hkk2','34aaa3','wessfhf', 'sdfjskdgfgffhfghlf','11gfhgfd1','fhh222','34ghgfd3','fghfg', 'ggggpo309834','111','222','343','wehf', 'sdfjsklf', 'sdfsdfsd','22hkk2','34aaa3','wessfhf', 'sdfjskdgfgffhfghlf','11gfhgfd1','fhh222','34ghgfd3','fghfg', 'ggggpo309834','111','222','343','wehf', 'sdfjsklf', 'sdfsdfsd','22hkk2','34aaa3','wessfhf', 'sdfjskdgfgffhfghlf','11gfhgfd1','fhh222','34ghgfd3','fghfg', 'ggggpo309834','111','222','343','wehf', 'sdfjsklf', 'sdfsdfsd','22hkk2','34aaa3','wessfhf', 'sdfjskdgfgffhfghlf','11gfhgfd1','fhh222','34ghgfd3','fghfg', 'ggggpo309834','111','222','343','wehf', 'sdfjsklf', 'sdfsdfsd','22hkk2','34aaa3','wessfhf', 'sdfjskdgfgffhfghlf','11gfhgfd1','fhh222','34ghgfd3','fghfg', 'ggggpo309834','111','222','343','wehf', 'sdfjsklf', 'sdfsdfsd','22hkk2','34aaa3','wessfhf', 'sdfjskdgfgffhfghlf','11gfhgfd1','fhh222','34ghgfd3','fghfg', 'ggggpo309834','111','222','343','wehf', 'sdfjsklf', 'sdfsdfsd','22hkk2','34aaa3','wessfhf', 'sdfjskdgfgffhfghlf','11gfhgfd1','fhh222','34ghgfd3','fghfg', 'ggggpo309834','111','222','343','wehf', 'sdfjsklf', 'sdfsdfsd','22hkk2','34aaa3','wessfhf', 'sdfjskdgfgffhfghlf','11gfhgfd1','fhh222','34ghgfd3','fghfg', 'ggggpo309834','111','222','343','wehf', 'sdfjsklf', 'sdfsdfsd','22hkk2','34aaa3','wessfhf', 'sdfjskdgfgffhfghlf','11gfhgfd1','fhh222','34ghgfd3','fghfg', 'ggggpo309834',]
            windowHeight: window.innerHeight,
            danmus: [],
            temps: [],
            isPlay: false,
            playIndex: null,
            audioUrl: null,
            showDialog: false,
            detail: null,
            isPlayDetail: false,
            isShowMyself: false,
            lastId: null,
            wishEndTime: null,
            isEnd: false,
            showWishDialog: false,
            isWishEnding: false,
            showWishBtn: false,
            rollArr: [],
            rollObj: {},
            tempArr: [], //暂存结果
            btnText: "暂停",
            wishTimer: null,
            showCodeDialog: false,
            showcheckWishDialog: false,
            isPhone: false,
            qrImgUrl: "",
            loading: false,
            showLikeGifId: false,
            showLikeGif: true,
            mySelfWishList: [],
            isMyselstWish: false,
            dialogVisible: false, // 控制视频弹窗的显示
            isHidden: false,
            dmSpeed: 60,
            showGuide: false, // 控制引导动画的显示
            isHideMedia: false, // 弹幕的图片和视频是否隐藏
        };
    },
    created() {
        this.getWishDetail();
        this.getDanmus();
    },
    async mounted() {
        const hasVisited = localStorage.getItem("hasVisited");
        if (!hasVisited) {
            this.showGuide = true; // 显示引导动画
            localStorage.setItem("hasVisited", "true"); // 标记用户已经访问过

            // 3秒后自动关闭引导动画
            setTimeout(() => {
                this.closeGuide();
            }, 3000);
        }
        window.addEventListener("resize", this.handleResize);
        console.log("this.$refs.danmaku", this.$refs.danmaku);
        // this.isHidden = true
        // this.dmSpeed = 400
        // this.$refs.danmaku.pause()
        // setTimeout(()=>{
        //     this.dmSpeed = 60
        //     this.isHidden = false
        //     this.$refs.danmaku.play()
        // },2000)
        await this.qryWishEndTimeFn();

        // this.openWishDialog()
        // this.loopGetResult()
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        closeGuide() {
            this.showGuide = false; // 关闭引导动画
        },
        videoDialogClose() {
            this.$nextTick(() => {
                const video = this.$refs.wishVideo;
                if (video) {
                    console.log("video", video);
                    video.currentTime = 0;
                    video.pause();
                }
            });
        },
        handleResize: debounce(() => {
            // 重新刷新页面
            window.location.reload();
        }, 200),
        // 判断当前查看的祝福是否是自己的
        isMyself(clickItem) {
            this.isMyselstWish =
                this.mySelfWishList &&
                this.mySelfWishList.map((i) => i.id).includes(clickItem.id);
        },
        getmedialist(detail) {
            return (
                (detail &&
                    detail?.picList?.length &&
                    detail.picList.map((item) => item.picUrl)) ||
                []
            );
        },
        handleLikeClick: debounce(function (e, danmu) {
            e.stopPropagation();
            if (danmu.myLikeState === 0) {
                // 弹幕点赞
                wishLike({
                    id: danmu.id,
                }).then((res) => {
                    if (res.code == "0") {
                        this.showLikeGifId = danmu.id; // 设置当前弹幕的动画显示
                        // 更新弹幕的点赞状态和数量
                        danmu.myLikeState = 1; // 直接更新当前点击的弹幕
                        danmu.likeNum += 1; // 增加点赞数量
                        // 两秒后隐藏动画并保持已点赞状态
                        setTimeout(() => {
                            this.showLikeGifId = null;
                        }, 2000);
                    } else {
                        if (res.msg !== "系统忙，请稍后再试") {
                            this.$message({
                                message: res.msg,
                                type: "warning",
                            });
                        }
                    }
                });
            } else if (danmu.myLikeState === 1) {
                // 取消点赞
                wishLike({
                    id: danmu.id,
                }).then((res) => {
                    if (res.code == "0") {
                        // 更新弹幕的点赞状态和数量
                        danmu.myLikeState = 0; // 更新为未点赞状态
                        danmu.likeNum -= 1; // 减少点赞数量
                        this.$message({
                            message: "取消点赞成功",
                            type: "success",
                        });
                    } else {
                        if (res.msg !== "系统忙，请稍后再试") {
                            this.$message({
                                message: res.msg,
                                type: "warning",
                            });
                        }
                    }
                });
            }
        }, 400),
        playVideo() {
            this.dialogVisible = true;
            this.$nextTick(() => {
                const video = this.$refs.wishVideo;
                if (video) {
                    console.log("video", video);
                    video.currentTime = 0;
                    video.play();
                }
            });
        },
        determineFileType(url) {
            // 定义常见的图片和视频扩展名
            const imageExtensions = [
                "jpg",
                "jpeg",
                "png",
                "gif",
                "bmp",
                "webp",
                "tiff",
                "svg",
            ];
            const videoExtensions = [
                "mp4",
                "avi",
                "mov",
                "wmv",
                "flv",
                "mkv",
                "webm",
                "ogg",
            ];

            // 提取 URL 中的扩展名，并转换为小写
            const extension = url
                .split(".")
                .pop()
                .toLowerCase()
                .split("?")[0]
                .split("#")[0];

            // 判断文件类型
            if (imageExtensions.includes(extension)) {
                return "image";
            } else if (videoExtensions.includes(extension)) {
                return "video";
            } else {
                return "unknown";
            }
        },
        // 检查是否登录
        checkLogin() {
            return localStorage.getItem("access_token");
        },

        // 获取统一登录链接
        applyfortokenFn() {
            applyfortoken(this.redirectUrl).then((res) => {
                if (res.code === "0") {
                    location.href = res.data;
                } else {
                    Toast.fail(res.msg);
                }
            });
        },
        // 判断是否是在同程管家里面发开的此页面
        getIsToca() {
            console.log(window.navigator.userAgent);
            if (window.navigator.userAgent.indexOf("toca") > -1) {
                return true;
            }
            return false;
        },
        // 获取太阳码
        getQrImgFn() {
            const bizid =
                "wish-" +
                CryptoJS.MD5(this.checkLogin()).toString().toUpperCase().substring(0, 16);
            const param = {
                appId: "wx0bb689f8ccb553db",
                bizId: bizid,
                refresh: false,
                client: "C",
                path: "pages/community/blankPageShare/blankPageShare",
                scene: "b=" + bizid,
                extend: `type=wish&access_token=${this.checkLogin()}&fromToca=${this.getIsToca()}&shopId=1000000000724`,
                // extend: `type=${
                //     this.isEnd ? "wish-wall" : "wish"
                // }&access_token=${this.checkLogin()}&fromToca=${this.getIsToca()}&shopId=1000000000724`,
                width: 280,
                backColor: "WHITE",
                smallProgramPath: "/pages/community/blankPageShare/blankPageShare",
                business: "600000",
                templateId: 589,
            };
            this.loading = true;
            console.log("this.isEnd", param, this.isEnd);
            getQrImg(param)
                .then((res) => {
                    console.log(res);
                    if (res.code === "0") {
                        this.qrImgUrl = res.data;
                        // 轮询本人心愿详情
                        // this.loopGetDetail();
                    } else {
                        Toast.fail(res.msg);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getQrImgFn2() {
            const bizid =
                "wish-" +
                CryptoJS.MD5(this.checkLogin()).toString().toUpperCase().substring(0, 16);
            const param = {
                appId: "wx0bb689f8ccb553db",
                bizId: bizid,
                refresh: false,
                client: "C",
                path: "pages/community/blankPageShare/blankPageShare",
                scene: "b=" + bizid,
                extend: `type=wish&access_token=${this.checkLogin()}&fromToca=${this.getIsToca()}&shopId=1000000000724`,
                // extend: `type=${
                //     this.isEnd ? "wish-wall" : "wish"
                // }&access_token=${this.checkLogin()}&fromToca=${this.getIsToca()}&shopId=1000000000724`,
                width: 280,
                backColor: "WHITE",
                smallProgramPath: "/pages/community/blankPageShare/blankPageShare",
                business: "600000",
                templateId: 589,
            };
            this.loading = true;
            console.log(param);
            getQrImg(param)
                .then((res) => {
                    console.log(res);
                    if (res.code === "0") {
                        this.qrImgUrl = res.data;
                        // 轮询本人心愿详情
                        // this.loopGetDetail();
                    } else {
                        Toast.fail(res.msg);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 点击传递你的心愿
        openWish() {
            // 如果授权登陆过了
            if (this.checkLogin()) {
                // 如果是移动端 就获取url scheme 跳转到小程序
                if (this.isPhone) {
                    // this.jump();
                } else {
                    this.showCodeDialog = true;
                    this.getQrImgFn();
                }
            } else {
                this.applyfortokenFn();
            }
        },
        openCheckWish() {
            // 如果授权登陆过了
            if (this.checkLogin()) {
                // 如果是移动端 就获取url scheme 跳转到小程序
                if (this.isPhone) {
                    // this.jump();
                } else {
                    this.showcheckWishDialog = true;
                    this.getQrImgFn2();
                }
            } else {
                this.applyfortokenFn();
            }
        },
        // 关闭太阳码弹窗
        closeQrDialog() {
            this.showCodeDialog = false;
        },
        loopGetResult() {
            let params = {
                drawCount: 8,
                wishGroup: "groupA",
            };
            doWishDraw(params).then((res) => {
                if (res.code === "0" && res.data) {
                    // 暂存结果
                    this.tempArr = res.data;
                } else {
                }
            });
        },
        pauseWishResult() {
            clearInterval(this.wishTimer);
            this.rollArr = this.tempArr;
            console.log(this.tempArr);
            let rollObj = {};
            this.rollArr.forEach((item) => {
                let idx = this.danmus.findIndex((it) => it.id === item.wishId);
                rollObj[idx] = true;
                if (this.isJsonString(item?.userPortrait)) {
                    item["userPortrait"] = JSON.parse(item?.userPortrait).original;
                } else {
                    item["userPortrait"] = item?.userPortrait;
                }
            });
            this.rollObj = rollObj;
            this.btnText = "关闭";
            this.isWishEnding = true;
            this.showWishBtn = false;
        },
        closeWishResult() {
            this.showWishDialog = false;
            this.isWishEnding = false;
            this.tempArr = [];
            this.rollArr = [];
            this.btnText = "暂停";
        },
        openWishDrawDialog() {
            this.loopGetResult();
            this.showWishDialog = true;
            this.wishTimer && clearInterval(this.wishTimer);
            this.wishTimer = setInterval(() => {
                let rollObj = {};
                let rollArr = [];
                while (rollArr.length < 8) {
                    let temp = Math.floor(Math.random() * this.danmus.length);
                    rollObj[temp] = true;
                    rollArr.push(this.danmus[temp]);
                }
                this.rollObj = rollObj;
                this.rollArr = rollArr;
            }, 100);
            this.isWishEnding = false;
        },
        // 关闭抽奖弹窗，清空数据
        getRandomArrayElements(count) {
            this.rollArr = [];
            console.log(1111);

            // var shuffled = arr.slice(0),
            //     i = arr.length,
            //     min = i - count,
            //     temp, index;
            // while (i-- > min) {
            //     index = Math.floor((i + 1) * Math.random());
            //     temp = shuffled[index];
            //     shuffled[index] = shuffled[i];
            //     shuffled[i] = temp;
            // }
            // return shuffled.slice(min);
        },
        isJsonString(str) {
            if (typeof str == "string") {
                try {
                    var obj = JSON.parse(str);
                    if (typeof obj == "object" && obj) {
                        return true;
                    } else {
                        return false;
                    }
                } catch (e) {
                    console.log("error：" + str + "!!!" + e);
                    return false;
                }
            }
        },
        getDanmus(startId, pageSize) {
            const param = {
                pageSize: 500,
                startId: 0,
            };
            getWishList(param).then((res) => {
                if (res.code === "0") {
                    res.data.map((v) => {
                        if (v?.userPortrait) {
                            if (this.isJsonString(v?.userPortrait)) {
                                v["userPortrait"] = JSON.parse(v?.userPortrait).original;
                            } else {
                                v["userPortrait"] = v?.userPortrait;
                            }
                        }
                    });
                    if (!startId) {
                        this.danmus = res.data;
                    } else {
                        res.data &&
                            res.data.length &&
                            res.data.forEach((v) => {
                                if (!this.danmus.find((sub) => sub.id === v.id)) {
                                    this.$refs.danmaku.push(v);
                                }
                            });
                        if (res.data && res.data.length)
                            this.lastId = res.data[res.data.length - 1].id;
                    }
                } else {
                    Toast.fail(res.msg);
                }

                // setTimeout(()=>{
                //     this.$refs.danmaku.pause();
                // }, 6000)
            });
        },
        // 点击播放或者 暂停
        playOrPause(item, index) {
            this.audioUrl = item.wishVoiceTempUrl;
            this.$nextTick(() => {
                this.playIndex = index;
                this.isPlay = !this.isPlay;
                if (this.isPlay) {
                    this.$refs.player.load();
                    this.$refs.player.play();
                } else {
                    this.$refs.player.pause();
                }
            });
        },
        // 点击查看心愿
        async openDetailDialog() {
            // this.isPlay = false;
            // this.isShowMyself = true;
            // this.$refs.player && this.$refs.player.pause();
            // await this.getWishDetail();
            // this.showDialog = true;
        },
        // 点击某个弹幕 弹出查看心愿弹窗
        openDetail(item) {
            this.isPlay = false;
            this.$refs.player && this.$refs.player.pause();
            this.detail = item;
            this.detail.picList =
                this.detail.picList &&
                this.detail.picList.map((item) => {
                    return {
                        ...item,
                        isClick: false,
                    };
                });
            this.isMyself(item);
            this.showDialog = true;
        },
        showMedia(item) {
            if (this.isHideMedia) {
                console.log(item);
                item.isClick = true;
            } else {
                if (item.picType == "video") {
                    this.playVideo();
                }
            }
        },
        // 关闭查看心愿弹框
        closePcDetail() {
            this.isPlay = false;
            this.isShowMyself = false;
            this.$refs.player && this.$refs.player.pause();
            this.showDialog = false;
        },
        // 播放或暂停 查看心愿语音
        playOrPauseDetail() {
            this.audioUrl = this.detail.wishVoiceTempUrl;
            this.$nextTick(() => {
                this.isPlayDetail = !this.isPlayDetail;
                if (this.isPlayDetail) {
                    this.$refs.player.load();
                    this.$refs.player.play();
                } else {
                    this.$refs.player.pause();
                }
            });
        },
        // 语音播放结束时触发
        ended() {
            console.log("--------end");
            this.isPlay = false;
            this.isPlayDetail = false;
            this.audioUrl = "";
        },
        // 获取本人心愿详情
        getWishDetail() {
            return new Promise((resolve) => {
                wishDetail({}).then((res) => {
                    if (res.code === "0") {
                        // if(this.isJsonString(res.data?.userPortrait)){
                        //     res.data["userPortrait"] = JSON.parse(res.data?.userPortrait).original;
                        // }
                        this.mySelfWishList = res.data;
                    } else {
                        Toast.fail(res.msg);
                    }
                    resolve();
                });
            });
        },
        // 所有弹幕插入完毕
        listEnd() {
            // const startId = this.danmus[this.danmus.length - 1].id;
            if (!this.lastId) this.lastId = this.danmus[this.danmus.length - 1].id;
            this.getDanmus(this.lastId, 100);
        },
        end() {
            console.log("222222222222");
        },
        // 获取视频链接
        qryWishEndTimeFn() {
            return new Promise((resolve) => {
                qryWishTime()
                    .then((res) => {
                        if (res.code === "0") {
                            const { beginTime, endTime, yearBeginTime } = res.data;
                            this.isEnd = isTimeReached(endTime);
                            this.isHideMedia = !this.computedTimeIsUp(yearBeginTime);
                            // this.isStart = false
                            // this.isStart = isTimeReached(beginTime)
                            // this.startTime = beginTime
                            // this.startTime = "2024-12-24 00:00:00"
                            console.log("this.isStart", this.startTime);
                        }
                    })
                    .catch(() => {
                        resolve(false);
                    });
            });
        },
        // 计算时间是否过期
        computedTimeIsUp(time) {
            // time = time ? time.replace(/-/g, '/') : '';
            const targetTime = new Date(time).getTime(); // 将目标时间转为时间戳
            const nowTime = Date.now(); // 当前时间戳
            const diff = targetTime - nowTime; // 计算时间差
            return diff <= 0;
        },
        getPreviewList() {
            const arr = this.detail.picList.filter((v) => v.picType === "pic");
            return arr.map((v) => {
                return v.picUrl;
            });
        },
    },
};
</script>

<style lang="scss">
.wish-wall {
    width: 100%;
    height: 100%;
    background: url("https://m.elongstatic.com/year-wish/2025new-year2.jpg");
    background-size: 100% 100%;
    position: relative;
    border: 0px solid transparent;
    position: absolute;
    left: 0;
    top: 0;

    .pc-title {
        width: 30%;
        margin: 0 auto;
        margin-top: 40px;
    }

    .wish-wrap {
        position: absolute;
        top: 18%;
        // left: 0;
        // width: 100%;
        left: -250px;
        width: calc(100% + 250px);
        height: 69%;
        padding: 24px 0;
    }

    .wish-wrap2 {
        position: absolute;
        top: 21%;
        width: 100%;
        //   height: 73%;
        height: calc(87% - 125px);
        //   border: 1px solid #333;
    }

    .noTorem-user-portrait > img {
        width: 40px;
        height: 40px;
        border-radius: 4px;
        // border-radius: 50%;
    }

    .user-portrait > img,
    .user-portrait .user-portrait-image {
        width: 60px;
        height: 60px;
        border-radius: 4px;
    }

    .noTorem-wish-box {
        // width: 555px;
        // min-height: 123px!important;
        // max-height: 202px;
        // // height: 194px;
        // padding: 8px;
        // background: rgba(243, 243, 243, .8);
        // border-radius: 8px;
        // display: flex;
        // justify-content: space-between;
        // box-sizing: border-box;
    }

    .wish-box {
        width: 409px;
        max-height: 194px;
        // height: 194px;
        padding: 8px;
        background: rgba(243, 243, 243, 0.8);
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
    }

    .noTorem-wish-bg {
        width: 470px;
        max-height: 152px;
        box-sizing: border-box;
        border-radius: 5px;
        z-index: 2;
        position: relative;
        background: #fff;
        opacity: 1 !important;
        display: flex;
        flex-direction: column;
        min-height: 70px;
        padding: 18px 54px 18px 18px;
        background: rgba(255, 255, 255, 0.6);
        border: 2px solid #ffffff;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        text-align: LEFT;
        color: #000000;
        line-height: 35px;
        border-radius: 0 25px 25px 25px;
        // filter: blur(50px);
    }

    .wish-bg {
        width: 347px;
        box-sizing: border-box;
        border-radius: 5px;
        z-index: 2;
        position: relative;
        background: #fff;
        opacity: 1 !important;
        display: flex;
        flex-direction: column;
        border: 1px solid #ececec;
        padding: 5px 12px 6px 10px;
    }

    .noTorem-wish-bg-triangle {
        display: block;
        position: absolute;
        left: -8px;
        top: 12px;

        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 14px solid white;
        border-bottom: 10px solid transparent;
    }

    .wish-bg-triangle {
        display: block;
        position: absolute;
        left: -8px;
        top: 12px;

        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 14px solid white;
        border-bottom: 10px solid transparent;
    }

    .noTorem-wish-bg-triangle2 {
        display: block;
        position: absolute;
        left: -7px;
        top: 14px;

        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-right: 12px solid white;
        border-bottom: 8px solid transparent;
    }

    .noTorem-wish-voice {
        padding: 5px 8px;
        height: 35.5px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ececec;
        cursor: pointer;
    }

    .wish-voice {
        padding: 5px 8px;
        height: 35.5px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ececec;
        cursor: pointer;
    }

    .noTorem-wish-right {
        // width: 86%;
        // width: 347px;
        // margin-left: 12px;
    }

    .wish-right {
        width: 347px;
    }

    .noTorem-wish-content {
        height: auto;
        max-height: 110px;
        font-size: 18px;
        line-height: 26px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: LEFT;
        color: #333333;
        // padding-top: 6.5px;
        // padding-right: 6px;
        box-sizing: border-box;

        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal;
    }

    .noTorem-wish-content3 {
        padding-top: 0 !important;
    }

    .wish-content {
        max-height: 310px;
        font-size: 14px;
        line-height: 26px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: LEFT;
        color: #333333;
        padding-top: 6.5px;
        padding-right: 6px;

        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal;
    }

    .noTorem-user-name {
        font-size: 18px;
        line-height: 14px;
        color: #666;
        margin-bottom: 12px;
    }

    .user-name {
        font-size: 26px;
        font-weight: 700;
        line-height: 24px;
        color: #980f16;
        margin-bottom: 10px;
        // margin-top: 5px;
    }

    .noTorem-voice-click-text {
        font-size: 14px;
        line-height: 14px;
        font-weight: 600;
        color: #980f16;
    }

    .voice-click-text {
        font-size: 14px;
        line-height: 14px;
        font-weight: 600;
        color: #980f16;
    }

    .show-btn {
        width: 522px;
        // width: 27.1875%;
        height: 128px;
        // height: 13.1958%;
        position: absolute;
        left: 50%;
        // bottom: 81px;
        bottom: 5%;
        transform: translate(-50%, 0);
        background: url("https://m.elongstatic.com/year-wish/checkMyBtn.png");
        background-repeat: no-repeat;
        background-size: 100%;
        z-index: 9;
        cursor: pointer;
    }

    .noTorem-show-btn {
        width: 522px;
        // width: 28.1857%;
        height: 128px;
        // height: 13%;
        position: absolute;
        left: 50%;
        bottom: 8.3505%;
        transform: translate(-50%, 0);
        background-image: url("https://m.elongstatic.com/year-wish/start.png");
        color: #fff;
        background-repeat: no-repeat;
        background-size: 100%;
        z-index: 9;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        // border-radius: 10%;
    }

    .noTorem-wish-box-end {
        text-align: center;

        .noTorem-end-icon {
            width: 145px;
            height: 145px;
            margin-top: 55px;
        }

        .noTorem-end-text {
            font-size: 14px;
            line-height: 14px;
            color: #666;
            margin-top: 13px;
        }
    }

    .end-box {
        text-align: center;

        .end-icon {
            width: 220px;
            height: 220px;
            margin-top: 80px;
        }

        .end-text {
            font-size: 24px;
            line-height: 24px;
            color: #666;
            margin-top: 24px;
            margin-bottom: 93px;
        }
    }

    .wrapper2 {
        display: flex;
        align-items: center;
        justify-content: center;
        // flex-direction: column;
        height: 100%;

        .noTorem-dialog {
            width: 600px;
            height: 520px;
            background-color: white;
            // background-size: 76px 74px;
            // background-position: 496px 63px;
            position: relative;
            background: #ffffff;
            border-radius: 40px;

            .noTorem-dialog-close {
                position: absolute;
                width: 60px;
                height: 60px;
                left: 50%;
                transform: translate(-50%, 0);
                bottom: -70px;
                cursor: pointer;
            }

            .noTorem-dialog-head {
                height: 56px;
                text-align: center;
                // border-bottom: 1px solid #efefef;
                position: relative;

                .noTorem-head-title {
                    font-size: 30px;
                    font-family: PingFang SC, PingFang SC-600;
                    font-weight: 600;
                    color: #333333;
                    line-height: 30px;
                    width: 100%;
                    text-align: center;
                    padding: 24px 0;
                }
            }

            .noTorem-dialog-foot {
                width: 100%;
                height: 56px;
                line-height: 56px;
                text-align: center;
                border-top: 1px solid #efefef;
                position: absolute;
                left: 0;
                bottom: 0;
                font-size: 18px;
                font-weight: 600;
                color: #980f16;
                cursor: pointer;
            }

            .noTorem-dialog-content {
                width: 409px;
                // height: 194px;
                background: #f3f3f3;
                margin: 0 auto;
                // margin-top: 46px;
                border-radius: 4px;
                overflow: hidden;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
        }

        .noTorem-user-portrait2 {
            width: 40px;
            height: 40px;
            border: 1px solid #e1e1e1;
            border-radius: 4px;
        }

        .user-name2 {
            margin-top: 8px;
            font-size: 14px;
            line-height: 14px;
            color: #666;
            margin-bottom: 12px;
            margin-top: 2px;
        }

        .wish-content2 {
            // max-height: 104px;
            font-size: 14px;
            line-height: 26px;
            color: #333;
        }
    }

    .pc-wrap {
        display: block;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .mobile-wrap {
        display: none;
    }

    .bg-title {
        // width: 684px;
        width: 91.2%;
        height: 161;
        // width: 91.2346%;
        // height: 7.7155%;
        display: block;
        margin: 0 auto;
        margin-top: 12.5615%;
    }

    .mobile-show-btn {
        width: 330px;
        height: 80px;
        background: linear-gradient(90deg, #fecf86, #ffe7b9 100%);
        border: 4px solid #ffffff;
        border-radius: 53px;
        box-shadow: 0px 5px 10px 0px rgba(243, 43, 41, 0.3);
        position: absolute;
        bottom: 12.3152%;
        // bottom: 200px;
        left: 50%;
        transform: translate(-50%, 0);
        text-align: center;
        line-height: 80px;
        color: #bf000a;
        font-size: 40px;
        font-weight: bold;
        z-index: 99;
        font-family: PingFang SC, PingFang SC-Bold;
        cursor: pointer;
    }

    .detail-dialog {
        // width: 640px;
        width: 85.3333%;
        height: 720px;
        border-radius: 16px;
        background: white;
        position: relative;
    }

    .heart-img {
        width: 456px;
        height: 256px;
        position: absolute;
        left: 50%;
        top: -116px;
        transform: translate(-50%, 0);
    }

    .detail-text {
        font-size: 32px;
        line-height: 32px;
        color: #333;
        font-weight: bold;
        text-align: center;
        margin-top: 108px;
    }

    .detail-content {
        // width: 576px;
        width: 90%;
        height: 300px;
        margin: 0 auto;
        border-radius: 10px;
        background: #eee;
        color: #333333;
        font-size: 28px;
        line-height: 42px;
        margin-top: 32px;
        overflow: hidden;
        box-sizing: border-box;

        .detail-content-text {
            // width: 100%;
            height: 256px;
            margin: 24px 35px 20px 36px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 6;
        }
    }

    .ok-btn {
        width: 270px;
        height: 80px;
        background: linear-gradient(90deg, #ff0039, #ff008a 100%);
        border-radius: 53px;
        box-shadow: 0px 5px 10px 0px rgba(243, 43, 41, 0.3);
        margin: 0 auto;
        // margin-top: 32px;
        color: white;
        text-align: center;
        line-height: 80px;
        font-size: 28px;
        font-weight: bold;
        cursor: pointer;
    }

    .play-box {
        margin-top: 16px;
        margin-bottom: 32px;
        margin-left: 32px;

        display: flex;
        align-items: center;
    }

    .play-desc {
        font-size: 28px;
        color: #999;
        margin-left: 16px;
    }

    .play-audio-box {
        width: 160px;
        height: 80px;
        line-height: 80px;
        border-radius: 8px;
        background: #95eb68;
        padding-left: 24px;
        position: relative;
        cursor: pointer;

        .audioPlay {
            display: inline-block;
            line-height: 80px;
        }
    }

    .lottery-wrap {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .lottery-box {
        width: 1758px;
        height: 682px;
        background-color: #ffefd7;
        border-radius: 4px;
        position: relative;
        // display: flex;
        // align-items: center;
        // justify-content: center;
    }

    .huxideng {
        width: 2000px;
        height: 750px;
        animation: mymove 5s infinite;
        -webkit-animation: mymove 5s infinite;
        /*Safari and Chrome*/
        -webkit-animation: mymove 5s infinite;
        // left: 0;
        position: absolute;
    }

    @keyframes mymove {
        0% {
            transform: scale(1);
            /*开始为原始大小*/
        }

        25% {
            transform: scale(1.06);
            /*放大1.1倍*/
        }

        50% {
            transform: scale(1);
        }

        75% {
            transform: scale(1.06);
        }
    }

    .lottery-title1 {
        // width: 483px;
        // height: 120px;
        width: 451px;
        height: 101px;
        position: absolute;
        left: 648px;
        top: -8%;
        z-index: 99;
    }

    .lottery-header {
        width: 100%;
        height: 56px;
        // background-color: rgb(212, 159, 159);
        display: flex;
        justify-content: flex-end;
        border-bottom: 1px solid #eee;

        img {
            margin: 10px 10px 0 0;
            width: 16px;
            height: 16px;
        }
    }

    .lottery-item-box {
        width: 100%;
        height: 480px;
        // height: 100%;
        // height: 194px;
        // width: 420px;
        // padding: 30px 0 0 0;
        // background-color: rgb(248, 219, 219);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 28px;
        overflow: hidden;

        .lottery-icon1 {
            z-index: 1;
            position: absolute;
            right: 2px;
            top: 2px;
        }
    }

    .lottery-arr {
        display: flex;
        justify-content: space-between;
        // width: 850px;
        // height: 88%;
        flex-wrap: wrap;
        align-items: center;
        background-color: #ffefd7;
        padding: 0 28px;
    }

    .lottery-item {
        z-index: 10;
        // background-color: #f3f3f3;
        opacity: 0.8;
        width: 393px;
        // height: 198px;
        // height: 40%;
        border-radius: 14px;
        padding: 8px;
        display: flex;
    }

    .lottery-block-box {
        margin-top: 28px;
        width: 409px;
        background: white;
        // height: 224px;
        border-radius: 5px;
        overflow: hidden;
    }

    .head-portrait {
        width: 40px;
        height: 40px;
        margin-right: 10px;

        img {
            width: 40px;
            height: 40px;
        }
    }

    .lottery-item-right {
        margin-left: 8px;
        width: 90%;
        height: 100%;
        // background-color: rgb(227, 174, 174);
    }

    .wish-bg1 {
        width: 100%;
        // height: 78%;
        box-sizing: border-box;
        border-radius: 5px;
        position: relative;
        background: #ffefd6;
        opacity: 1 !important;
        display: flex;
        flex-direction: column;
        // border: 1px solid #ececec;
        padding: 5px 12px 6px 10px;
    }

    .wish-bg-triangle1 {
        display: block;
        position: absolute;
        left: -8px;
        top: 12px;
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 14px solid white;
        border-bottom: 10px solid transparent;
    }

    .wish-voice1 {
        padding: 5px 8px;
        // height: 20%;
        height: 36px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid rgba(152, 15, 22, 0.1);
        cursor: pointer;
    }

    .wish-content2 {
        min-height: 124px;
        font-size: 20px;
        line-height: 26px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: LEFT;
        color: #980f16;
        padding-top: 6.5px;
        padding-right: 6px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal;
    }

    .wish-content3 {
        height: 160px;

        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal;
    }

    .wish-draw-btn {
        width: 240px;
        height: 60px;
        display: flex;
        // align-items: center;
        // justify-content: center;
        // background-color: #409EFF;
        // color: #fff;
        // border-radius: 8px;
        cursor: pointer;
    }

    .lottery-footer {
        border-top: 1px solid #eee;
        width: 100%;
        height: 94px;
        // color: #980F16;
        display: flex;
        align-items: center;
        justify-content: center;
        // cursor: pointer;
        // font-size: 20px;
    }

    .img-arr {
        position: fixed;
        top: -1000px;
    }

    .img-arr img {
        width: 40px;
        height: 40px;
    }

    //当屏幕最小宽度为992px
    @media screen and (max-width: 500px) {
        .home {
            background: url("https://m.elongstatic.com/year-wish/wishBg2024.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            height: 100vh;
        }

        .pc-wrap {
            display: none;
        }

        .mobile-wrap {
            display: block;
        }
    }

    .hide {
        display: none;
    }

    .pc-logo {
        width: 405px;
        display: block;
        position: absolute;
        top: 20px;
        left: 20px;
    }

    .noTorem-like-box {
        z-index: 2;
        position: absolute;
        width: 60px;
        height: 60px;
        background: #ffffff;
        border: 2px solid #ffffff;
        border-radius: 50%;
        top: 50%;
        right: -40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transform: translateY(-50%);
        padding: 4px;
        cursor: pointer;

        .noTorem-likeNum {
            font-size: 20px;
            font-family: PingFang SC, PingFang SC-400;
            font-weight: 400;
            text-align: CENTER;
            color: #333333;
            line-height: 20px;
        }

        .noTorem-like-gif {
            width: 60px;
            height: 60px;
            position: absolute;
            top: -18px;
            right: 2px;
        }

        .noTorem-like-img {
            width: 40px;
            height: 40px;

            .noTorem-unlike {
                width: 40px;
                height: 40px;
            }

            .noTorem-like {
                width: 40px;
                height: 40px;
            }
        }
    }

    .checkWishWrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        .dialog {
            width: 600px;
            // height: 520px;
            background-color: white;
            position: relative;
            // border-radius: 4px;
            border-radius: 60px;
            padding-bottom: 32px;

            .dialog-close {
                position: absolute;
                width: 80px;
                height: 80px;
                left: 50%;
                transform: translate(-50%, 0);
                bottom: -102px;
            }

            .dialog-head {
                width: 100%;
                text-align: center;
                padding: 24px 0;
                font-size: 30px;
                font-family: PingFang SC, PingFang SC-600;
                font-weight: 600;
                text-align: center;
                color: #333333;
                line-height: 30px;
            }

            .wish-box-end {
                // height: 100%;
                margin-top: 54px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .pc-end-icon {
                    width: 245px;
                    height: 245px;
                }

                .pc-end-text {
                    font-size: 20px;
                    line-height: 20px;
                    color: #666;
                    margin-top: 13px;
                }
            }

            .wish-content-box {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .wish-txt {
                    width: 536px;
                    // height: 197px;
                    background: #f6f4fc;
                    border-radius: 20px;
                    padding: 21px 30px;
                    box-sizing: border-box;
                    font-size: 20px;
                    font-family: PingFang SC, PingFang SC-400;
                    font-weight: 400;
                    color: #000000;
                    line-height: 35px;
                }
            }

            .media {
                padding: 0 38px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex-wrap: wrap;
                gap: 6px;
                margin-top: 14px;

                .filterBlur {
                    filter: blur(0px) !important;
                }

                .media-item {
                    width: 100px;
                    height: 100px;
                    border-radius: 20px;
                    position: relative;

                    .media-image {
                        object-fit: cover;
                        width: 100px;
                        height: 100px;
                        border-radius: 20px;
                    }

                    .videoPlayIcon {
                        position: absolute;
                        width: 43px;
                        height: 43px;
                        transform: translate(-50%, -50%);
                        top: 50%;
                        left: 50%;
                        z-index: 2;
                    }

                    .unLookIcon {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 90%;
                        // height: 90%;
                        z-index: 2;
                    }
                }
            }
        }
    }

    .codeWrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        .dialog {
            width: 600px;
            height: 500px;
            background-color: white;
            position: relative;
            // border-radius: 4px;
            border-radius: 60px;

            .qr-bg {
                width: 160px;
                height: 182px;
                left: 50%;
                top: -85px;
                position: absolute;
                transform: translate(-50%, 0);
            }

            .dialog-close {
                position: absolute;
                width: 80px;
                height: 80px;
                left: 50%;
                transform: translate(-50%, 0);
                bottom: -102px;
            }

            .qr-img {
                width: 300px;
                height: 300px;
                margin: 0 auto;
                margin-top: 110px;
                text-align: center;
                overflow: hidden;
                // border: 1px solid #dcdcdc;
                border-radius: 8px;
            }

            .loading {
                margin-top: 100px;
            }

            .qr-desc {
                font-weight: 600;
                text-align: center;
                margin-top: 28px;
                font-size: 20px;
                font-family: PingFang SC, PingFang SC-500;
                text-align: CENTER;
                color: #333333;
                line-height: 14px;
            }

            .qrImgUrl {
                width: 100%;
                height: 100%;
                position: relative;
                z-index: 999;
                background: white;
            }
        }

        .overlay {
            width: 640px;
            box-sizing: border-box;
            // max-height: 736px;
            // min-height: 480px;
            // height: 542px;
            background-color: white;
            position: relative;
            border-radius: 16px;
            padding-bottom: 60px;
            // padding: 0 32px;
            // padding-top: 48px;
            // padding-bottom: 16px;
            // box-sizing: border-box;

            .dialog-close2 {
                position: absolute;
                width: 30px;
                height: 30px;
                top: 32px;
                right: 32px;
            }

            .example-box {
                width: 527px;
                // height: 193px;
                background: rgb(243, 243, 243, 0.8);
                border-radius: 10px;
                // opacity: 0.8;
                padding: 10px 16px 16px 10px;
                box-sizing: border-box;
                margin: 0 auto;

                display: flex;
                align-items: flex-start;
            }

            .box1 {
                margin-top: 80px;
            }

            .avatar {
                width: 60px;
                height: 60px;
                border: 1px solid #e1e1e1;
                border-radius: 5px;
            }

            .example-right {
                margin-left: 14.86px;
            }

            .user-name {
                font-size: 22px;
                font-family: PingFang SC, PingFang SC-Regular;
                color: #666666;
                line-height: 22px;
            }

            .example-text {
                width: 420px;
                // width: 86.8263%;
                // height: 134px;
                background: white;
                border: 1.27px solid #ececec;
                padding: 13px;
                border-radius: 8px;
                box-sizing: border-box;
                margin-top: 10px;
                position: relative;

                .example-triangle {
                    display: block;
                    position: absolute;
                    left: -10px;
                    top: 24px;

                    width: 0;
                    height: 0;
                    border-top: 10px solid transparent;
                    border-right: 14px solid white;
                    border-bottom: 10px solid transparent;
                }

                .example-txt {
                    width: 100%;
                    // height: 107px;
                    font-size: 24px;
                    line-height: 36px;
                    color: #333;

                    // overflow: hidden;
                    // text-overflow: ellipsis;
                    // display: -webkit-box;
                    // -webkit-box-orient: vertical;
                    // -webkit-line-clamp: 3;
                }
            }
        }

        .video-container {
            width: 100%;
            height: 500px;
            overflow: hidden;
            display: flex !important;
            flex-direction: column !important;
        }

        .video-player {
            width: 100%;
            height: 100%;
        }
    }

    .dialog-box {
        .el-dialog {
            background: #000 !important;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .el-dialog__close {
                font-size: 48px !important;
            }
        }
    }

    /* 隐藏全屏按钮 */
    video::-webkit-media-controls-fullscreen-button {
        display: none !important;
    }

    video::-moz-media-controls-fullscreen-button {
        display: none !important;
    }

    video::-ms-media-controls-fullscreen-button {
        display: none !important;
    }

    video::media-controls-fullscreen-button {
        display: none !important;
    }

    .vue-danmaku {
        .danmus {
            top: 2px !important;
        }
    }

    @keyframes breathe {
        0%,
        100% {
            transform: scale(1);
        }

        50% {
            transform: scale(1.15);
        }
    }

    .click-tips-box {
        width: 100%;
        height: 100%;
        display: flex;
        align-content: center;
        justify-content: center;
        flex-direction: column;

        .tip-div {
            display: flex;
            justify-content: center;

            img {
                width: 100px;
                margin-bottom: 32px;
                animation: breathe 1s ease-in-out infinite;
            }
        }

        .click-tip {
            font-size: 24px;
            font-family: PingFang SC, PingFang SC-400;
            font-weight: 400;
            text-align: center;
            color: #ffffff;
            line-height: 32px;
        }
    }

    .hide-media {
        filter: blur(6px);
    }
}
</style>
